import { TableV2 } from '@anytag/shared-atoms';
import { InstagramInteractionPost } from '@anytag/graphql';
import { PostDetailsType, TableData } from '@anytag/shared-types';
import { InstagramInteractionMentionedPostDetailsModal } from '@anytag/shared-molecules';
import { useAnalyticsInstagramMentionedPostsListTable } from './hooks';

export interface AnalyticsInstagramMentionedPostsListProps extends TableData<InstagramInteractionPost> {
  mainSocialAccountId: number;
}

export const AnalyticsInstagramMentionedPostsList = ({
  loading,
  data = [],
  mainSocialAccountId
}: AnalyticsInstagramMentionedPostsListProps) => {
  const { columns } = useAnalyticsInstagramMentionedPostsListTable();

  return (
    <>
      <TableV2 loading={loading} data={data} columns={columns} rowHeight="62px" noTopBorderRadius hasBorder />

      <InstagramInteractionMentionedPostDetailsModal
        posts={data.map(({ id }): PostDetailsType => ({ id, mainSocialAccountId }))}
      />
    </>
  );
};
